import { Robonomics as R } from "robonomics-interface";

const Robonomics = {
  getInstance(name) {
    return R.getInstance(name);
  }
};

export { Robonomics };
